module.exports = __webpack_public_path__ + "img/symbol_7.43eff3bb.png";